/**
 * G4 -- is the Arabic catalogue real yet?
 *
 * Switching to Arabic today gives right-to-left layout with English
 * text in guillemets: 62 wrapped strings and five Arabic characters,
 * all of them in the logo. That is not Arabic support, and offering
 * the control makes it look like broken Arabic support rather than
 * absent Arabic support. A SAMA bank evaluating the product cannot
 * tell those two things apart.
 *
 * DERIVED from the catalogue rather than declared in a flag. A boolean
 * someone has to remember to flip is a boolean that will be wrong: it
 * can claim a translation that does not exist, or hide one that does.
 * The scaffold wraps every leaf in guillemets (see markUntranslated),
 * so the catalogue itself already knows the answer.
 *
 * "partial" is a first-class state because it is the expected delivery
 * shape -- the fix list asks for the catalogue in the order business
 * users meet it, home and My Work first, "with the guillemet scaffold
 * retained only for keys not yet translated". A half-translated
 * catalogue SHOWS the toggle: some real Arabic beats none, and the
 * remaining guillemets say honestly which parts are outstanding.
 */

export type CatalogueState = "scaffold" | "partial" | "complete";

const OPEN = "‹";

function countLeaves(node: unknown, seen: { total: number; marked: number }): void {
  if (typeof node === "string") {
    seen.total += 1;
    if (node.startsWith(OPEN)) seen.marked += 1;
    return;
  }
  if (node !== null && typeof node === "object") {
    for (const value of Object.values(node)) countLeaves(value, seen);
  }
}

/**
 * Walks the whole catalogue once. Called at module load and memoised
 * by the caller -- a few thousand string comparisons, and the answer
 * cannot go stale because the input cannot change at runtime.
 */
export function catalogueState(catalogue: unknown): CatalogueState {
  const seen = { total: 0, marked: 0 };
  countLeaves(catalogue, seen);
  if (seen.total === 0) return "scaffold";
  if (seen.marked === seen.total) return "scaffold";
  if (seen.marked === 0) return "complete";
  return "partial";
}
